import { initReactI18next } from 'react-i18next';
import i18next, { i18n } from 'i18next';
import { inject, injectable } from 'inversify';

import enTranslation from '@/assets/locales/en/translation.json';
import idnTranslation from '@/assets/locales/idn/translation.json';
import ruTranslation from '@/assets/locales/ru/translation.json';

import ConfigService from '../ConfigService';
import ServiceTypes from '../ServiceTypes';

import type { II18Service } from './types';

/**
 * Сервис интернационализации
 */
@injectable()
class I18Service implements II18Service {
  _i18n: i18n;

  constructor(@inject(ServiceTypes.Config) private _configService: ConfigService) {
    const { language, currency } = this._configService.settings;
    this._i18n = i18next.use(initReactI18next).createInstance(
      {
        lng: language,
        debug: false,
        detection: {
          order: ['cookie'],
          caches: ['cookie'],
        },
        resources: {
          ru: {
            translation: ruTranslation,
          },
          en: {
            translation: enTranslation,
          },
          idn: {
            translation: idnTranslation,
          },
        },
      },
      err => {
        if (err) {
          throw new Error(`[I18N]: ${err}`);
        }
      },
    );

    this._i18n.services.formatter?.add(
      'currency',
      (value, lng, { style = 'currency', currencyDisplay }) => {
        return new Intl.NumberFormat(lng, {
          style,
          currency,
          maximumFractionDigits: 0,
          currencyDisplay,
        }).format(value);
      },
    );
  }

  get i18n() {
    return this._i18n;
  }
}

export default I18Service;
